// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICardShipmentEventDto } from './ICardShipmentEventDto';
import {
    ICardShipmentEventDtoFromJSON,
    ICardShipmentEventDtoFromJSONTyped,
    ICardShipmentEventDtoToJSON,
    ICardShipmentEventDtoToJSONTyped,
} from './ICardShipmentEventDto';

/**
 * 
 * @export
 * @interface ICardShipmentEventsDto
 */
export interface ICardShipmentEventsDto {
    /**
     * 
     * @type {number}
     * @memberof ICardShipmentEventsDto
     */
    card_id?: number;
    /**
     * 
     * @type {Array<ICardShipmentEventDto>}
     * @memberof ICardShipmentEventsDto
     */
    events?: Array<ICardShipmentEventDto>;
}

/**
 * Check if a given object implements the ICardShipmentEventsDto interface.
 */
export function instanceOfICardShipmentEventsDto(value: object): value is ICardShipmentEventsDto {
    return true;
}

export function ICardShipmentEventsDtoFromJSON(json: any): ICardShipmentEventsDto {
    return ICardShipmentEventsDtoFromJSONTyped(json, false);
}

export function ICardShipmentEventsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardShipmentEventsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'card_id': json['card_id'] == null ? undefined : json['card_id'],
        'events': json['events'] == null ? undefined : ((json['events'] as Array<any>).map(ICardShipmentEventDtoFromJSON)),
    };
}

export function ICardShipmentEventsDtoToJSON(json: any): ICardShipmentEventsDto {
    return ICardShipmentEventsDtoToJSONTyped(json, false);
}

export function ICardShipmentEventsDtoToJSONTyped(value?: ICardShipmentEventsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'card_id': value['card_id'],
        'events': value['events'] == null ? undefined : ((value['events'] as Array<any>).map(ICardShipmentEventDtoToJSON)),
    };
}

